module.exports = __webpack_public_path__ + "static/media/us-gold-currency-logo-vert.48aa44c0.png";